module.exports = "/call-frontend/img/蓝.588a9493.png";